import { useMutation, useQueryClient } from '@tanstack/react-query'
import http from '../../utils/Http/Http'

type SetUserGHLTokenResponse = {
	message: string
	updated_attributes?: Record<string, any>
}

export async function setUserGHLToken(queryParams: URLSearchParams): Promise<SetUserGHLTokenResponse> {
	const code = queryParams.get('code')
	const marketplace = queryParams.get('marketplace')
	console.log(code, marketplace)
	const response = await http({
		method: 'put',
		url: '/ghl/auth_token',
		headers: {
			'Content-Type': 'application/json',
		},
		data: { code, marketplace },
	})

	return response.data
}

export default function useSetUserGHLToken(queryKey = ['user']) {
	const queryClient = useQueryClient()
	const mutation = useMutation<SetUserGHLTokenResponse, Error, URLSearchParams>({
		mutationFn: (queryParams) => setUserGHLToken(queryParams),
		onSuccess: () => queryClient.invalidateQueries({ queryKey }),
		onError: (error) => {
			console.error(error)
		},
	})

	return {
		setUserGHLToken: (queryParams: URLSearchParams) => mutation.mutate(queryParams),
		error: mutation.error,
		isLoading: mutation.isPending,
	}
}
